// extracted by mini-css-extract-plugin
export default {"controlBtn":"UWctf_1J3G716vFlJg1w","overlay":"eSvombPb_vn8TBDBtv_Q"};